<div>
  <h4 class="mb-4 text-muted">Dashboard</h4>

  <div class="row">
    <div class="col-md-6 col-lg-3 mb-4">
      <div class="card border-0 rounded-0">
        <div class="card-body">
          <div class="card-innerBody d-flex align-items-center">
            <div class="col-md-4 card-icon text-light">
              <i class="pi pi-users" aria-hidden="true"></i>
            </div>
            <div class="ml-auto">
              <p class="card-label text-right text-muted">Usuarios</p>
              <h4 class="card-text text-right">
                @if (data!=null) {
                {{ data.cant_user }}
                }
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex">
          <small class="text-muted">Usuarios registrados</small>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-3 mb-4">
      <div class="card border-0 rounded-0">
        <div class="card-body">
          <div class="card-innerBody d-flex align-items-center">
            <div class="col-md-4 card-icon text-light">
              <i class="pi pi-car" aria-hidden="true"></i>
            </div>
            <div class="ml-auto">
              <p class="card-label text-right text-muted">Conductores</p>
              <h4 class="card-text text-right">
                @if (data!=null) {
                {{ data.cant_driver }}
                }
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex">
          <small class="text-muted">Conductores Registrados</small>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-3 mb-4">
      <div class="card border-0 rounded-0">
        <div class="card-body">
          <div class="card-innerBody d-flex align-items-center">
            <div class="col-md-4 card-icon text-light">
              <i class="pi pi-bars" aria-hidden="true"></i>
            </div>
            <div class="ml-auto">
              <p class="card-label text-right text-muted">Carreras Mensuales</p>
              <h4 class="card-text text-right">
                @if (data!=null) {
                {{ data.cant_car_trip_month }}
                }
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex">
          <small class="text-muted">Total de carreras mensuales</small>
        </div>
      </div>
    </div>

    <div class="col-md-6 col-lg-3 mb-4">
      <div class="card border-0 rounded-0">
        <div class="card-body">
          <div class="card-innerBody d-flex align-items-center">
            <div class="col-md-4 card-icon text-light">
              <i class="pi pi-check-square" aria-hidden="true"></i>
            </div>
            <div class="ml-auto">
              <p class="card-label text-right text-muted">Carreras Aceptadas</p>
              <h4 class="card-text text-right">
                @if (data!=null) {
                {{ data.cant_car_trip_accept }}
                }
              </h4>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex">
          <small class="text-muted">Total de carreras aceptadas</small>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-xl-6 mb-4 align-items-stretch">
      <div class="card h-100 border-0 rounded-0">
        <div class="card-title mb-1 p-3 d-flex">
          <h6>Usuarios por Ciudad</h6>
          <a class="btn ml-auto p-0 text-lightning">
            <i class="fas fa-ellipsis-h"></i>
          </a>
        </div>
        <div class="card-body">
          <div
            class="chart-container d-flex h-100 align-items-center justify-content-center"
            style="position: relative"
          >
            <div class="row">
              <div class="col-6">
                <canvas id="chart-users"></canvas>
              </div>
              <div class="col-6">
                <p-table [value]="userData" styleClass="p-datatable-sm">
                  <ng-template pTemplate="body" let-row>
                    <tr>
                      <td [ngStyle]="{ 'background-color': row.color }"></td>
                      <td>{{ row.itemLabel }}</td>
                      <td>{{ row.itemValue }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="legend d-flex just">
            <div class="flex-fill text-center">
              <small> USUARIOS REGISTRADOS: {{ totalUsers }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-6 mb-4 align-items-stretch">
      <div class="card h-100 border-0 rounded-0">
        <div class="card-title mb-1 p-3 d-flex">
          <h6>Conductores por Ciudad</h6>
          <a class="btn ml-auto p-0 text-lightning">
            <i class="fas fa-ellipsis-h"></i>
          </a>
        </div>
        <div class="card-body">
          <div
            class="chart-container d-flex h-100 align-items-center justify-content-center"
            style="position: relative"
          >
            <div class="row">
              <div class="col-6">
                <canvas id="chart-drivers"></canvas>
              </div>

              <div class="col-6">
                <p-table [value]="driverData" styleClass="p-datatable-sm">
                  <ng-template pTemplate="body" let-row>
                    <tr>
                      <td [ngStyle]="{ 'background-color': row.color }"></td>
                      <td>{{ row.itemLabel }}</td>
                      <td>{{ row.itemValue }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="legend d-flex just">
            <div class="flex-fill text-center">
              <small> CONDUCTORES REGISTRADOS: {{ totalDrivers }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-xl-6 mb-4 align-items-stretch">
      <div class="card h-100 border-0 rounded-0">
        <div class="card-title mb-1 p-3 d-flex">
          <h6>Carreras por Ciudad</h6>
          <a class="btn ml-auto p-0 text-lightning">
            <i class="fas fa-ellipsis-h"></i>
          </a>
          
        </div>
        <div class="card-body">
          <p-dropdown
            [options]="monthsList"
            [(ngModel)]="selectedPeriod"
            optionLabel="label"
            placeholder="Selecciona un mes"
            (onChange)="onPeriodChange($event)"
            appendTo="body"
          ></p-dropdown>

          <p-dropdown
            [options]="statusCarTrip"
            [(ngModel)]="selectedStatus"
            optionLabel="label"
            placeholder="Selecciona un mes"
            (onChange)="onStatusChange($event)"
            appendTo="body"
          ></p-dropdown>

          <div
            class="chart-container d-flex h-100 align-items-center justify-content-center"
            style="position: relative"
          >
            <div class="row">
              <div class="col-6">
                <canvas id="chart-car-trip"></canvas>
              </div>

              <div class="col-6">
                <p-table [value]="carTripData" styleClass="p-datatable-sm custom-table">
                  <ng-template pTemplate="body" let-row>
                    <tr>
                      <td [ngStyle]="{ 'background-color': row.color }">
                      </td>
                      <td>{{ row.itemLabel }}</td>
                      <td>{{ row.itemValue }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <div class="legend d-flex just">
            <div class="flex-fill text-center">
              <small> CARRERAS DEL MES: {{ totalCarTrip }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
